export enum USER_INFO_ACTIONS {
  SET_USER_INFO = 'USER_INFO_ACTIONS.SET_USER_INFO',
  SET_USER_PROFILE = 'USER_INFO_ACTIONS.SET_USER_PROFILE',
  SET_SUBMITTING_KYC_DATA = 'USER_INFO_ACTIONS.SET_SUBMITTING_KYC_DATA',
}
